import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Contacto</h4>
          <p>Email: info@importaciones.com</p>
          <p>Teléfono: +123 456 7890</p>
        </div>
        <div className="footer-section">
          <h4>Síguenos</h4>
          <p>Facebook</p>
          <p>Instagram</p>
          <p>TikTok</p>
        </div>
        <div className="footer-section">
          <h4>Información</h4>
          <p>Envíos y devoluciones</p>
          <p>Términos y condiciones</p>
          <p>Política de privacidad</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 Importaciones. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;